import { Button, DatePicker, Select } from "antd";
import { FC, useCallback, useEffect, useState } from "react";
import { Translate } from "react-redux-i18n";
import { FLEX, useDatesFilter, useStatusesFilter } from "./helpers";
import { useActions } from "../../../../../../hooks/useActions";
import { useSelector } from "react-redux";
import store, { RootState } from "../../../../../../store";
import { Dayjs } from "dayjs";
import { DATE_TIME_FORMAT } from "../../../../../../utils";
import { getSurveyInstances } from "../../../../../../store/slices/surveys/surveysService";
import { TabKeysEnum } from "../helpers";
import { getStatusFilterOptions } from "../../../../../../utils/getStatusFilterOptions";
import { FilterStatus } from "../../../../../../types/filterStatusValue";

const Filters: FC<{ activeKey: TabKeysEnum }> = ({ activeKey }) => {
  const { resetSurveyInstanceFilters$, setSurveyInstanceFilters$ } = useActions();
  const { selectedDates, setSelectedDates, resetDates } = useDatesFilter();
  const { selectedStatus, setSelectedStatus, resetStatuses } = useStatusesFilter();
  const filters = useSelector((state: RootState) => state.surveys.surveyInstance.filters);
  const [isFirstRender, setIsFirstRender] = useState(true);
  const statusOption = getStatusFilterOptions();

  const applyFilters = useCallback(() => {
    const obj = {
      ...filters,
      ...(!!selectedDates[0] && !!selectedDates[1]
        ? {
            from: (selectedDates[0] as Dayjs).format(DATE_TIME_FORMAT),
            to: (selectedDates[1] as Dayjs).format(DATE_TIME_FORMAT),
          }
        : { from: undefined, to: undefined }),
    };

    switch (selectedStatus) {
      case FilterStatus.ALL:
        obj.finished = true;
        obj.notFinished = true;
        break;
      case FilterStatus.FINISHED:
        obj.finished = true;
        obj.notFinished = false;
        break;
      case FilterStatus.ACTIVE:
        obj.finished = false;
        obj.notFinished = true;
        break;
    }

    setSurveyInstanceFilters$(obj);
  }, [filters, selectedDates, selectedStatus]);

  const resetFilters = useCallback(async () => {
    resetSurveyInstanceFilters$();
    resetDates();
    resetStatuses();

    const surveyId = store.getState().surveys.current?.surveyId;
    if (surveyId) {
      await store.dispatch(getSurveyInstances(surveyId));
    }
  }, []);

  useEffect(() => {
    if (isFirstRender) {
      resetFilters().then();
      setIsFirstRender(false);
    }
  }, [activeKey, isFirstRender, resetFilters, setIsFirstRender]);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24, margin: "24px 0" }}>
      <div style={{ ...FLEX }}>
        <DatePicker.RangePicker
          style={{ marginRight: 24 }}
          showTime={{ format: "HH:mm" }}
          format="YYYY-MM-DD HH:mm"
          value={selectedDates}
          onChange={(value) => {
            if (value === null) {
              resetDates();
            } else if (Array.isArray(value)) {
              setSelectedDates(value);
            }
          }}
          inputReadOnly
        />
        <div style={{ ...FLEX, gap: 10 }}>
          <Select<FilterStatus>
            style={{ width: 160 }}
            value={selectedStatus}
            onChange={(value: FilterStatus) => {
              setSelectedStatus(value);
            }}
          >
            {statusOption.map((option: any) => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
          <Button onClick={applyFilters} type={"primary"}>
            <Translate value={"display"} />
          </Button>
          <Button onClick={resetFilters} type={"default"}>
            <Translate value={"resetFilters"} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Filters;
